import laravelAxiosClient from "../laravelAxiosClient";
import {
  CivilitesResult,
  SyndicatsAffiliesResult,
} from "../interfaces/referentiels.interface";

export const findCivilites = async () => {
  const { data } = await laravelAxiosClient.get<CivilitesResult>("/civilites");
  return data;
};

export const findSyndicatsAffilies = async (departement: string) => {
  const { data } = await laravelAxiosClient.get<SyndicatsAffiliesResult>("/syndicats/affilies", {
    params: { departement },
  });
  return data;
};
